import React, { useEffect, useState } from "react";
import beneficiaryStatusesAPI from "../../_api/_beneficiaryStatusesAPI";
import {
  Box,
  Tooltip,
  Select,
  MenuItem,
  Chip,
  CircularProgress,
} from "@mui/material";
import peopleAPI from "../../_api/_people";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import axios from "axios";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const Status: React.FC<{
  personId: string;
  currentStatus: any;
  updateStatus?: (status: any) => void;
  profile?: boolean;
  setCurrentStatus?: any;
  header?: boolean;
}> = ({
  personId,
  currentStatus,
  updateStatus,
  profile,
  setCurrentStatus,
  header,
}) => {
  const { t } = useTranslation("common");

  const [status, setStatus] = useState<any>(currentStatus);
  const [statusPossible, setStatusPossible] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState<any>(
    currentStatus?.code
  );
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(true);
  const [hasChanged, setHasChanged] = useState(false);

  useEffect(() => {
    // if (currentStatus) {
    if (!profile) {
      setSelectedStatus(currentStatus?.code);

      setStatus((current: any) => {
        setHasChanged(current?.code !== currentStatus?.code);
        return currentStatus;
      });
    }
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStatus]);

  useEffect(() => {
    if (!profile) {
      updateStatus?.(status);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = async () => {
    hasChanged && (await handleClick());

    setOpen(true);
  };

  const handleClick = async () => {
    setHasChanged(false);
    const apiUrl = `${beneficiaryStatusesAPI.url}/next?person.id=${personId}&current=${status?.code}`;

    if (!personId || !currentStatus) return;
    setLoading(true);
    try {
      const response = await axios.get(apiUrl);
      setStatusPossible(response?.data["hydra:member"]);
    } catch (error) {
      console.error("Error fetching next status:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (status: any) => {
    try {
      setLoading(true);
      await peopleAPI.patch(`${personId}/status`, {
        status: status,
      });

      const newStatus = statusPossible.find(
        (item: any) => item.code === status
      );
      setStatus(newStatus);

      updateStatus?.(newStatus);

      toast.success(t("profilepage.success_edit_status"));
      await handleClick();
    } catch (err) {
      toast.error(t("errors.error_append"));
    } finally {
      setLoading(false);
    }
  };

  const handleSelectChange = (event: any) => {
    setSelectedStatus(event.target.value);
    handleStatusChange(event.target.value);
    setOpen(false);
  };

  useEffect(() => {
    const updatedStatus = statusPossible.find(
      (item: any) => item.code === selectedStatus
    );
    if (updatedStatus) {
      setStatus(updatedStatus);
    }
  }, [selectedStatus, statusPossible]);

  useEffect(() => {
    if (setCurrentStatus) {
      setCurrentStatus(status);
    }
  }, [setCurrentStatus, status]);

  return (
    <Box sx={{ mt: 1, display: "flex", justifyContent: "center" }}>
      {loading ? (
        <Chip
          sx={{
            backgroundColor: header ? "#B4EC51" : status?.color,
            color: !header ? "white" : undefined,
            height: header ? "40px" : 30,
            fontSize: header ? "14px" : undefined,
            borderRadius: 5,

            display: "flex",
            alignItems: "center",
          }}
          label={
            <>
              {status?.status}
              <CircularProgress
                size={14}
                sx={{
                  fontSize: header ? "24px" : "16px",
                  padding: header ? "2px" : undefined,
                  marginLeft: "12px",
                  color: "white",
                }}
              />
            </>
          }
        />
      ) : (
        <Tooltip
          title={!header ? status?.description : null}
          placement="top-start"
        >
          {statusPossible.length > 0 ? (
            <Select
              onClose={handleClose}
              onOpen={handleOpen}
              open={open}
              value={selectedStatus}
              onChange={handleSelectChange}
              autoWidth
              IconComponent={() => (
                <KeyboardArrowDownIcon
                  sx={{
                    color: !header ? "white" : undefined,
                    fontSize: header ? "24px" : "16px",
                    backgroundColor: header ? "white" : undefined,
                    borderRadius: header ? "50%" : undefined,
                    padding: header ? "2px" : undefined,
                    marginLeft: header ? "12px" : undefined,
                  }}
                />
              )}
              sx={{
                height: header ? "40px" : 30,
                fontSize: header ? "14px" : undefined,
                backgroundColor: header ? "#B4EC51" : status?.color,
                color: header ? undefined : "white",
                paddingRight: 2,
                borderRadius: 5,
                border: 0,
                "&:hover": {
                  border: 0,
                  outline: "none",
                  backgroundColor: header ? "#A3D944" : "#FF5733",
                },
                "&:focus": {
                  border: 0,
                  outline: "none",
                },
                "&:focus-visible": {
                  border: 0,
                  outline: "none",
                },
                "& .MuiOutlinedInput-input": {
                  paddingRight: "1px !important",
                },
              }}
            >
              <MenuItem
                sx={{ display: "none" }}
                key={status?.code}
                value={status?.code}
              >
                {status?.status}
              </MenuItem>

              {statusPossible?.map((item: any) => (
                <MenuItem key={item.code} value={item.code}>
                  {item.status}
                </MenuItem>
              ))}
            </Select>
          ) : (
            <Chip
              sx={{
                "&:hover": {
                  border: 0,
                  outline: "none",
                  backgroundColor: header ? "#A3D944" : "undefined",
                },
                backgroundColor: header ? "#B4EC51" : status?.color,
                color: !header ? "white" : undefined,
                height: header ? "40px" : 30,
                fontSize: header ? "14px" : undefined,
                borderRadius: 5,
              }}
              onClick={handleClick}
              label={
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {status?.status}
                  <KeyboardArrowDownIcon
                    fontSize="small"
                    sx={{
                      color: !header ? "white" : undefined,
                      fontSize: header ? "24px" : "16px",
                      backgroundColor: header ? "white" : undefined,
                      borderRadius: header ? "50%" : undefined,
                      padding: header ? "2px" : undefined,
                      marginLeft: header ? "12px" : undefined,
                    }}
                  />
                </Box>
              }
            />
          )}
        </Tooltip>
      )}
    </Box>
  );
};

export default Status;
